exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../node_modules/css-loader/index.js?{\"sourceMap\":false}!../static-appopensalud/css/general.css"), "");
exports.i(require("-!../node_modules/css-loader/index.js?{\"sourceMap\":false}!../static-appopensalud/css/navbar.css"), "");

// module
exports.push([module.id, "\n.fade-enter-active, .fade-leave-active {\n  -webkit-transition: opacity .4s;\n  transition: opacity .4s;\n}\n.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {\n  opacity: 0;\n}\n.dropdown-item img {\n  margin-right:10px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7ba5bd90","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 1350
// module chunks = 120